<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 37 32"
  >
    <g>
      <path
        fill="#4365e2"
        d="M12.573 0h-8.002c-2.523 0.003-4.568 2.047-4.571 4.57v9.144c0.003 2.523 2.047 4.568 4.57 4.571h4.573v1.708c-0.001 2.208-1.791 3.998-4 4h-1.145c0 0 0 0 0 0-1.578 0-2.858 1.279-2.858 2.858 0 0.003 0 0.005 0 0.008v-0 2.287c0 1.578 1.279 2.858 2.858 2.858v0h1.142c6.622-0.008 11.988-5.371 12.002-11.99v-15.441c-0.003-2.523-2.047-4.568-4.57-4.571h-0zM14.859 20.011c0 5.365-4.35 9.715-9.715 9.715v0h-1.144c-0.315-0.001-0.57-0.256-0.571-0.571v-2.287c0.001-0.315 0.256-0.57 0.571-0.571h1.142c3.472 0 6.286-2.814 6.286-6.286v0-4.009h-6.857c-0.001 0-0.002 0-0.002 0-1.261 0-2.284-1.023-2.284-2.284 0-0.001 0-0.002 0-0.003v0-9.144c0-0.001 0-0.002 0-0.002 0-1.261 1.023-2.284 2.284-2.284 0.001 0 0.002 0 0.003 0h8.002c0.001 0 0.002 0 0.002 0 1.261 0 2.284 1.023 2.284 2.284 0 0.001 0 0.002 0 0.003v-0zM32 0h-7.999c-2.523 0.003-4.568 2.047-4.571 4.57v9.144c0.003 2.523 2.047 4.568 4.57 4.571h4.571v1.708c-0.001 2.208-1.791 3.998-4 4h-1.145c-1.577 0.001-2.855 1.28-2.855 2.858 0 0.003 0 0.005 0 0.008v-0 2.287c0.001 1.576 1.279 2.854 2.855 2.855h1.142c6.622-0.007 11.989-5.369 12.004-11.988v-15.441c-0.003-2.524-2.049-4.569-4.573-4.571h-0zM34.287 20.011c0 5.365-4.35 9.715-9.715 9.715v0h-1.145c-0.315-0.001-0.57-0.256-0.571-0.571v-2.287c0.001-0.315 0.256-0.57 0.571-0.571h1.142c0.001 0 0.002 0 0.002 0 3.472 0 6.286-2.814 6.286-6.286v0-4.009h-6.857c-1.26-0.001-2.282-1.024-2.282-2.284 0-0.001 0-0.002 0-0.003v0-9.144c0-0.001 0-0.002 0-0.002 0-1.261 1.023-2.284 2.284-2.284 0.001 0 0.002 0 0.003 0h7.999c0.001 0 0.002 0 0.002 0 1.261 0 2.284 1.023 2.284 2.284 0 0.001 0 0.002 0 0.003v-0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
